// utils.js

// export function isFieldSigned(field_id) {
//     return field_id.startsWith('sign_');
//   }

export function isFieldSigned(field_id, form_multiple_type, form_chat_person,form_officers,  field_multiple_type) {
//   if (field_multiple_type==='mapprover_external') {
//     console.log('isFieldSigned field_id: ' + field_id)
//     console.log('isFieldSigned form_multiple_type: ' + form_multiple_type)
//     console.log('isFieldSigned form_chat_person: ' + form_chat_person)
//     console.log('isFieldSigned form_officers: ' + form_officers)
//     console.log('isFieldSigned field_multiple_type '+field_multiple_type)
//     console.log('field_multiple_type === "mapprover_officer"',field_multiple_type === "mapprover_officer")
//     console.log('form_officers.includes(form_chat_person)',form_officers.includes(form_chat_person))
  
//     console.log('isFieldSigned true or false',field_id, form_multiple_type === "mapprover_external" &&
//     form_officers.includes(form_chat_person) &&
//     (field_id.startsWith("user_approver_")) || field_id.startsWith("user_action_") &&
//     field_multiple_type === "mapprover_officer")
//     console.log('isFieldSigned Condition 1:', form_multiple_type === "mapprover_external");
// console.log('isFieldSigned Condition 2:', form_officers.includes(form_chat_person));
// console.log('isFieldSigned Condition 3:', field_id.startsWith("user_approver_") || field_id.startsWith("user_action_"));
// console.log('isFieldSigned Condition 4:', field_multiple_type === "mapprover_officer");
    
  
//   }

  if (

    form_multiple_type === "mapprover_external" &&
    form_officers.includes(form_chat_person) &&
    (field_id.startsWith("user_approver_") || field_id.startsWith("user_action_")) &&
    field_multiple_type === "mapprover_officer"
  ) {
    return true;
  }
  
  return field_id.startsWith('sign_');
}


// utils.js

export function determineIsDisabled(
  formUserLock,
  formPageType,
  field_multiple_id,
  isSigned,
  field_id,
  formApprovalIndex,
  field_disabled_approver,
  field_disabled,
  formStatus
) {



  let isDisabled=false;
  console.log('formPageType: ' + formPageType)
  // if (formUserLock && (formPageType === 'user' || formPageType === null || formPageType === undefined)) {
  if (formUserLock && formPageType !== "official") {
    console.log('formPageType inside: ' + formPageType)
    isDisabled = true;
  } else if (formPageType === 'user') {
    if (field_multiple_id === 'mapprover') {

      console.log('determineIsDisabled mapprover here',isSigned,(field_id.startsWith('user_approver_') ||
      field_id.startsWith('user_action_')),parseInt(field_id.slice(-1)) < formApprovalIndex, parseInt(field_id.slice(-1)), formApprovalIndex)
      isDisabled =
        isSigned ||
        (field_id.startsWith('user_approver_') ||
          field_id.startsWith('user_action_')) &&
          parseInt(field_id.match(/\d+/)[0]) < formApprovalIndex;


    } else {
      isDisabled = true;
    }
  } else {
    isDisabled =
      field_disabled_approver === '1' ||
      field_disabled ||
      isSigned ||
      (formStatus === 'Submitted' &&
        (field_multiple_id === 'mapprover' ||
          field_id.startsWith('user_approver_')));
  }

  return isDisabled;
}